export default {
  callingAPI: false,
  PsjID: '', // 注册人员ID
  PsnID: '', // 展会报名成功后参展人员ID
  isPreviousUser: false,
  userInfo: {}
}



// WEBPACK FOOTER //
// ./src/store/state.js